var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.rdList.length > 0 ? _c('div', {
    staticClass: "live-icons"
  }, [_c('div', {
    staticClass: "swiper-container icons-list",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.rdList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide item",
      on: {
        "click": function click($event) {
          return _vm.gotoUrl(item.url);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imagePath,
        "alt": ""
      }
    })]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };